import {
  Bookmark,
  BookmarkCheck,
  Check,
  ChevronDown,
  Clock,
  ExternalLink,
  Menu,
  ShieldCheck,
  X,
} from 'lucide-react'

/**
 * Lucide icon wrapper.
 *
 * The design project loaded Lucide 0.469 from a CDN and injected SVG
 * imperatively; here the same glyphs come from `lucide-react` (same version),
 * so nothing is fetched at runtime and the icons are tree-shaken into the
 * bundle. Register new glyphs in REGISTRY — no other change is needed.
 */
const REGISTRY = {
  bookmark: Bookmark,
  'bookmark-check': BookmarkCheck,
  check: Check,
  'chevron-down': ChevronDown,
  clock: Clock,
  'external-link': ExternalLink,
  menu: Menu,
  'shield-check': ShieldCheck,
  x: X,
}

export function Icon({ name, size = 20, strokeWidth = 2, style, title }) {
  const Glyph = REGISTRY[name]

  return (
    <span
      style={{
        display: 'inline-flex',
        width: size,
        height: size,
        flex: 'none',
        color: 'inherit',
        ...style,
      }}
      /* Icons in this design always sit next to their own text label, so they
         are decorative unless an explicit title is passed. */
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : undefined}
      aria-label={title}
    >
      {Glyph ? (
        <Glyph width={size} height={size} strokeWidth={strokeWidth} />
      ) : null}
    </span>
  )
}

export default Icon
